export const REQUESTS_AUTO_REFUND_SLICE_NAME = "requestsAutoRefund"
